import SidebarItem from "./SidebarItem";

const Sidebar = () => {
  return (
    <aside className="hidden lg:block w-[240px] border-r-[6px] border-r-[#F7F5F2] ">
      <div className="h-[calc(100vh-120px)] sticky top-[92px]">
        <div className="w-full rounded-[10px] bg-white p-4">
          <div className="space-y-3">
            <SidebarItem to="/solutions" end>Solution</SidebarItem>
            <SidebarItem to="/integration" end>Integration</SidebarItem>
            <SidebarItem to="/demo" end>Demo</SidebarItem>
            <SidebarItem to="/get-started" end>Get Started</SidebarItem>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;